import React, { Component } from "react";
import { login } from "../../utils/AuthService";
import "../../scss/pages/login.scss";
import logo from "../../img/logo.png";
import { withRouter } from "utils/WithRouter";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      errors: "",
    };
  }

  handlingErrors = (err) => {
    this.setState({ errors: err });
  };

  login = (e) => {
    if (this.state.username && this.state.password) {
      login(this.state.username, this.state.password, this.props.history, this.handlingErrors);
      this.setState({ username: "", password: "" });
    } else {
      this.setState({
        errors: (this.state.username ? "" : "Username can't be empty. ") + (this.state.password ? "" : "Password can't be empty. "),
      });
    }
    e.preventDefault();
  };

  render() {
    return (
      <div className="container mt-2 login-page">
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="card-group mb-0">
              <div className="card p-2">
                <div className="card-block">
                  <img className="login-logo" src={logo} alt="Graziano’s" />
                  <h1>Login</h1>
                  <p className="text-muted">Sign In to your account</p>
                  {this.state.errors ? <div className="login-error" role="alert">{this.state.errors}</div> : ""}
                  <form onSubmit={this.login}>
                    <label htmlFor="login-username">Username</label>
                    <div className="input-group mb-1">
                      <span className="input-group-addon">
                        <i className="icon-user"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        id="login-username" name="username" autoComplete="username"
                        placeholder="Username"
                        value={this.state.username}
                        onChange={(e) => this.setState({ username: e.target.value })}
                      />
                    </div>
                    <label htmlFor="login-password">Password</label>
                    <div className="input-group mb-2">
                      <span className="input-group-addon">
                        <i className="icon-lock"></i>
                      </span>
                      <input
                        type="password"
                        className="form-control"
                        id="login-password" name="password" autoComplete="current-password"
                        placeholder="Password"
                        value={this.state.password}
                        onChange={(e) => this.setState({ password: e.target.value })}
                      />
                    </div>
                    <div className="row">
                      <div className="col-12 text-center">
                        <button type="submit" className="btn btn-primary login-buton" title="Sign in to your account">
                          Login
                        </button>
                      </div>
                    </div>
                  </form>
                  <div style={{ marginTop: "20px" }} className="text-center">
                  <a href="http://www.grazianosgroup.com/">Grazianos</a> &copy; 2025 - 5.0-beta
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login);
